/* eslint-disable */
// 封装的 websocket 类

var MySocket = function (url, baseUrl) {
    this.url;
    // socket 对象
    this.socket;
    // 心跳状态，false时不能执行操作, 等待重连
    this.heartStatus = false;
    this.count = 0;

    // 重连状态 避免 不间断的重连操作
    this.isReconnect = false;
    this.real_url;

    // 判断 base_url
    if (baseUrl === '/Service') {
        var domain = window.location.host;
        this.real_url = domain + baseUrl;
    } else if (baseUrl == '/taskServer') {
        var domain = window.location.host;
        this.real_url = domain + baseUrl;
    } else {
        this.real_url = baseUrl.split('//')[1];
    }
    this.url = 'ws://' + this.real_url + url;
    // 自定义 socket 函数

    this.onopen = function (e) {
        this.heartStatus = true;
        console.info(url+' :: 连接成功 :: '+ new Date().toUTCString(), this.socket.readyState);
    }

    this.onerror = ((e) => {
        console.warn(e.currentTarget.url, '连接异常!', new Date().toUTCString());
        this.heartStatus = false;
    })

    this.onclose = ((e) => {
        console.warn(url+' :: 连接关闭 :: '+ new Date().toUTCString());
    })

    this.initSocket();
}


MySocket.prototype.initSocket = function (fn) {
    
    if (!window.WebSocket) {
        console.error('浏览器不支持');
        return ;
    }
    var that = this;

    this.socket = new WebSocket(this.url);

    this.socket.onopen = function (e) {
        that.onopen();
    }

    this.socket.onclose = function (e) {
        that.onclose(e);
        that.socket = null;
    }

    this.socket.onerror = function (e) {
        that.onerror(e);
    }
   
    return this;
}


// 发送消息
MySocket.prototype.sendMsg = function (params) {
    return new Promise((resolve, reject) => {
        if (params == null) {
            console.log('msg is null');
        } else {
            try{
                this.socket.send(params);
                this.socket.onmessage = function (e) {
                    if (e.data !== 'ok') {
                        let data = JSON.parse(e.data);
                        if (data.hasOwnProperty('data')) {
                            // if (typeof(data) == 'undefined') return;
                            // console.log(data);
                            resolve(data);
                        } else {
                            console.log('First Response Successful!', data)
                        }
                    }
                }
            } catch (e) {
                // console.warn('error: ', e);
                reject(e)
            }
        }
    })
}

// 强制关闭
MySocket.prototype.force_close = function () {
    this.socket.close()
}

export default {
    MySocket
}